/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Export_Complete_TextInputs */



/**
* | output |
* | --- |
* | "Caption file published successfully to Ateliere Connect." |
*
* @param {Ateliere_Connect_Export_Complete_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_export_complete_text = /** @type {((inputs?: Ateliere_Connect_Export_Complete_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Export_Complete_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier de sous-titres publié avec succès sur Ateliere Connect.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Untertiteldatei wurde erfolgreich in Ateliere Connect veröffentlicht.")
	if (locale === "it") return /** @type {LocalizedString} */ ("File didascalia pubblicato correttamente su Ateliere Connect.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Файл с субтитрами успешно опубликован в Ateliere Connect.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo de subtítulo publicado exitosamente en Ateliere Connect.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕文件已成功发布到 Ateliere Connect。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプション ファイルが Ateliere Connect に正常に公開されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन फाइल एटेलियर कनेक्ट पर सफलतापूर्वक प्रकाशित हो गई है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legenda publicada com sucesso no Ateliere Connect.")
	return /** @type {LocalizedString} */ ("Caption file published successfully to Ateliere Connect.")
});